import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, StatusCodeActive, Undefined } from "utils/Constant";
import { ApiCreateCustomer, ApiCreateProduct, ApiGetBrandList, ApiGetCategoryList, ApiGetCustomerById, ApiGetProductById, ApiUpdateCustomer, ApiUpdateProduct } from "utils/constants/api";
import { CheckResponse, GetStatus, money, removeNonNumeric } from "utils/helpers";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import moment from "moment";
import ImageIcon from "assets/icon/ImageIcon";
import { useCallApi } from "api/apiHooks";

export default function CustomerForm(){
    let navigate = useNavigate()

    const { openModal, closeModal } = useModal()
    const { fetchCustomerById, fetchCreateCustomer, fetchUpdateCustomer} = useCallApi()

    const { fetch: apiCreateCustomer } = useFetch(ApiCreateCustomer)
    const { fetch: apiUpdateCustomer } = useFetch(ApiUpdateCustomer)
    const { fetch: apiGetCustomerById } = useFetch(ApiGetCustomerById)
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let customerId = queryString.get("customerId")
    
    const [customerName, setCustomerName] = useState('')
    const [idNumber, setIdNumber] = useState('')
    const [address, setAddress] = useState('-')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('-')
    const [instagram, setInstagram] = useState('-')
    const [idPhotoFile, setIdPhotoFile] = useState('')
    const [idPhotoFileUrl, setIdPhotoFileUrl] = useState('')
    
    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')

    // Event
    const handleIdPhotoChange = (e) => {
        setIdPhotoFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setIdPhotoFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        fetchCreateCustomer(
                            customerName,
                            idNumber, 
                            address,
                            phone,
                            email,
                            instagram,
                            idPhotoFile
                        ).then((res) => {
                            if (CheckResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/customer") 
                                    }
                                })
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    } else {
                        fetchUpdateCustomer(
                            customerId,
                            customerName,
                            idNumber, 
                            address,
                            phone,
                            email,
                            instagram,
                            idPhotoFile
                        ).then((res) => {
                            if (CheckResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/customer") 
                                    }
                                })
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    }                    
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    // Function
    const validation = () => {        
        if (customerName === null){
            openModal(ModalTypeFail, { message: 'Customer Name is required!' })
            return false
        }
        if (idNumber === '') {
            openModal(ModalTypeFail, { message: 'Id Number is required!' })
            return false
        }
        if (address === '') {
            openModal(ModalTypeFail, { message: 'Address is required!' })
            return false
        }
        if (email === '') {
            openModal(ModalTypeFail, { message: 'Email is required!' })
            return false
        }
        if (phone === '') {
            openModal(ModalTypeFail, { message: 'Phone is required!' })
            return false
        }
        if (instagram === '') {
            openModal(ModalTypeFail, { message: 'Instagram is required!' })
            return false
        }

        return true
    }
    
    useEffect(() => {
        // If Form Type Edit then get data
        if (formType === FormTypeEdit) {
            openModal(ModalTypeLoading)

            fetchCustomerById(customerId).then((res) => {
                if (CheckResponse(res)) {
                    let data = res.data

                    setCustomerName(data.customerName)
                    setIdNumber(data.idNumber)
                    setAddress(data.address)
                    setPhone(data.phone)
                    setEmail(data.email)
                    setInstagram(data.instagram)
                    setIdPhotoFileUrl(data.idPhotoUrl)

                    // Header
                    setStatus(data.status)
                    setCreateBy(data.createBy)
                    setCreateDate(data.createDate)
                    setUpdateBy(data.updateBy)
                    setUpdateDate(data.updateDate)

                    closeModal()
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                }
            })
        }
    }, [])

    return(
        <div className="p-3">
            <div className="flex flex-col justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full border">
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">Customer Detail</span>
                        <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | By : {updateBy}
                            </span>
                        </div>
                    </div>
                    <hr />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Photo ID */}
                        <CardForm title='Photo ID'>
                            <img
                                className="w-auto h-[200px] object-cover mx-auto border rounded-md"
                                src={idPhotoFileUrl}
                                alt="ID"
                            />
                            <input className="hidden" id="idPhoto" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleIdPhotoChange} />
                            <button onClick={() => document.getElementById('idPhoto').click()} 
                                className="mt-2 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center"
                            >
                                <ImageIcon />
                                Add Image
                            </button>
                        </CardForm>

                        {/* Customer Name */}
                        <CardForm title='Customer Name'>
                            <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value) }} maxLength={40} />
                        </CardForm>

                        {/* Id Number */}
                        <CardForm title='Id Number'>
                            <input className="input" value={idNumber} onChange={(e) => { setIdNumber(removeNonNumeric(e.target.value)) }} maxLength={16} />
                        </CardForm>
                        
                        {/* Address */}
                        <CardForm title='Address'>
                            <input className="input" value={address} onChange={(e) => { setAddress(e.target.value) }} maxLength={40} />
                        </CardForm>

                        {/* Email */}
                        <CardForm title='Email'>
                            <input className="input" value={email} onChange={(e) => { setEmail(e.target.value) }} maxLength={40} />
                        </CardForm>

                        {/* Phone */}
                        <CardForm title='Phone'>
                            <input className="input" value={phone} onChange={(e) => { setPhone(removeNonNumeric(e.target.value)) }} maxLength={16} />
                        </CardForm>

                        {/* Instagram */}
                        <CardForm title='Instagram'>
                            <input className="input" value={instagram} onChange={(e) => { setInstagram(e.target.value) }} maxLength={40} />
                        </CardForm>
                    </div>
                </div>            

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}

const CardForm = ({ title, children}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}